import React from 'react';
import PropertyGridUtils from '../PropertyGridUtils';


import "brace/theme/chrome";
import CodeEditor from './CodeEditor';
import js_beautify from 'js-beautify';

export default class JsEditor extends CodeEditor {
    mode = "javascript"
    format() {
        if (this.currentEditor) {
            // window.testEditor = this.currentEditor
            let session = this.currentEditor.getSession();
            // var cursorPosition = this.currentEditor.getCursorPosition();
            let value = js_beautify(session.getValue());
            this.setState({
                value
            })
            // session.setValue(value);
            // this.currentEditor.gotoLine(cursorPosition.row + 1, cursorPosition.column, true);
        }
    }
    render() {
        return super.render();
    }
}

PropertyGridUtils.register("js", (source, propertyGrid) => <JsEditor source={source} propertyGrid={propertyGrid} />);